import { CachedChartResponse, EStreamCachedChartEntry, QuoteChartEntry } from '../../types';
import { identity, Loadable, LoadableState, parseDateFromEStreamChart } from '../../utils';

type EStreamCachedChartDataLoader = (ric: string) => Promise<CachedChartResponse>;
type ChartDataTransformer = (data: QuoteChartEntry[]) => QuoteChartEntry[];
type QuoteStateSetter = (
  action: (current: LoadableState<QuoteChartEntry[]>) => LoadableState<QuoteChartEntry[]>,
) => void;

type LoadCachedChartParams = {
  reload?: boolean;
  ric: string;
  setter: QuoteStateSetter;
  loader: EStreamCachedChartDataLoader;
  transform?: ChartDataTransformer;
};

export const loadCachedChart = async ({
  ric,
  reload,
  setter,
  loader,
  transform = identity,
}: LoadCachedChartParams): Promise<boolean> => {
  setter(quotes => (!reload && Loadable.hasValue(quotes) ? Loadable.loadingWith(quotes) : Loadable.loading));
  try {
    const response = await loader(ric);
    const newQuotes = response.data.map(mapEStreamCachedChartEntry);
    const newChartData = Loadable.loaded(transform(newQuotes));
    setter(() => newChartData);
    return true;
  } catch (e) {
    setter(() => Loadable.failed);
    return false;
  }
};

const mapEStreamCachedChartEntry = ({ T, C: value }: EStreamCachedChartEntry, index: number): QuoteChartEntry => {
  const date = parseDateFromEStreamChart(T);
  return {
    value,
    index,
    date,
    timestamp: date.getTime(),
  };
};
